import React from "react";
import Quizzes from "./Quizzes";
import QuizEditor from "./QuizEditor";
import {Route, Switch, useHistory, useParams, useRouteMatch} from "react-router-dom";
import {useEventContext} from "../../../context";

const QuizRoute = ({onClose}) => {
    const {quizId} = useParams();

    return (
        <QuizEditor
            quizId={quizId}
            onClose={onClose}
        />
    );
}

export default () => {
    const {event} = useEventContext();
    const history = useHistory();
    const {path, url} = useRouteMatch();

    const setCurrentQuiz = (quiz) => {
        history.push(url + (quiz ? `/${quiz.id}` : ''));
    }

    if (!event.moduleQuiz.enabled) {
        return <p>Модуль не активен</p>
    }

    return (
        <Switch>
            <Route path={`${path}/:quizId`}>
                <QuizRoute onClose={() => setCurrentQuiz()} />
            </Route>
            <Quizzes
                onEditQuiz={setCurrentQuiz}
            />
        </Switch>
    );
}
